const UserRoles = {
  Admin: '1',
  User: '2'
};

export default UserRoles;
